import React from "react";
import { Link } from "react-router-dom";
import {
  Grid,
  Typography,
  Paper,
  Box,
  Container,
  Divider,
} from "@mui/material";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import { useSelector } from "react-redux";

const HTMLSitemap = () => {
  // Define categories for better organization
  const state = useSelector((state) => state);

  const categories = {
    "Main Pages": [
      { path: "/", title: "Home" },
      { path: "/about-us/", title: "About Us" },
      { path: "/contact-us/", title: "Contact Us" },
      { path: "/careers/", title: "Careers" },
      { path: "/blog/", title: "Blog" },
      { path: "/casestudies/", title: "Case Studies" },
    ],
    "Digital Marketing": [
      { path: "/digital-marketing/", title: "Digital Marketing" },
      { path: "/programmatic-advertising/", title: "Programmatic Advertising" },
      { path: "/ad-operations/", title: "Ad Operations" },
      { path: "/pay-per-click/", title: "Pay Per Click" },
      {
        path: "/search-engine-optimization/",
        title: "Search Engine Optimization",
      },
      { path: "/publishers-management/", title: "Publishers Management" },
      { path: "/social-media-management/", title: "Social Media Management" },
      { path: "/branding/", title: "Branding" },
      {
        path: "/conversion-rate-optimization/",
        title: "Conversion Rate Optimization",
      },
      { path: "/content-marketing/", title: "Content Marketing" },
    ],
    "Web, App & Design": [
      { path: "/web-design/", title: "Web Design" },
      {
        path: "/mobile-application-development/",
        title: "Mobile Application Development",
      },
      { path: "/e-commerce/", title: "E-Commerce" },
      { path: "/uiux/", title: "UI/UX Design" },
    ],
    "Analytics & Data": [
      { path: "/end-to-end-analytics/", title: "End-to-End Analytics" },
      { path: "/data-visualization/", title: "Data Visualization" },
      { path: "/google-analytics-setup/", title: "Google Analytics Setup" },
    ],
    "Other Services": [
      { path: "/video-production/", title: "Video Production" },
    ],
  };

  return (
    <>
      <Sidebar />

      <div
        className="anigrad"
        style={{
          paddingBottom: "50px",
        }}
      >
        <div
          style={{
            height: "50vh",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            width: "100vw",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              width: "75vw",
              marginLeft: state.auth.isMobile ? "0px" : "0px",
            }}
          >
            <div
              style={{
                fontSize: state.auth.isMobile ? "50px" : "80px",
                color: "yellow",
                zIndex: 999,
                textAlign: state.auth.isMobile ? "center" : "left",
              }}
            >
              HTML Sitemap
            </div>

            <div
              style={{
                borderBottom: "2px solid white",
                width: "100%",
                margin: "15px 0px 15px 0px",
              }}
            ></div>
            <div
              style={{
                fontSize: state.auth.isMobile ? "20px" : "3vh",
                color: "white",
                zIndex: 999,
              }}
            >
              Find all our pages and services in one place
            </div>
          </div>
        </div>
      </div>
      <div style={{ width: "100%", backgroundColor: "white" }}>
        <Container maxWidth="lg" sx={{ mt: 12, mb: 8, textAlign: "left" }}>
          {Object.entries(categories).map(([category, links], index) => (
            <Box key={category} sx={{ mb: 10 }}>
              <Typography
                variant="h5"
                component="h2"
                gutterBottom
                sx={{ fontWeight: "bold", color: "#1868DD" }}
              >
                {category}
              </Typography>
              <Divider sx={{ mb: 2 }} />
              <Grid container spacing={2}>
                {links.map((link) => (
                  <Grid item xs={12} sm={6} md={4} key={link.path}>
                    <Link
                      to={link.path}
                      style={{
                        textDecoration: "none",
                        color: "#333",
                        display: "block",
                        padding: "10px",
                        borderRadius: "4px",
                        transition: "background-color 0.3s",
                        "&:hover": {
                          backgroundColor: "#f5f5f5",
                          textDecoration: "underline",
                        },
                      }}
                    >
                      <Typography variant="body1">{link.title}</Typography>
                    </Link>
                  </Grid>
                ))}
              </Grid>
            </Box>
          ))}
        </Container>
      </div>

      <Footer />
    </>
  );
};

export default HTMLSitemap;
